import {
  CLEAR_ALBUM_MEMBERSHIP_GROUP_FILTERS,
  SET_ACTIVE_IDENTITY,
  SET_PENDING_PURCHASING_OPTION,
  TOGGLE_ALBUM_MEMBERSHIP_GROUP_FILTER,
} from './membershipsActions';

export const initialState = {
  activeIdentity: null,
  pendingPurchasingOption: null,
  albumMembershipGroupFilters: [],
};

const membershipsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ACTIVE_IDENTITY: {
      return {
        ...state,
        activeIdentity: action.identity,
      };
    }

    case SET_PENDING_PURCHASING_OPTION: {
      return {
        ...state,
        pendingPurchasingOption: action.item,
      };
    }

    case TOGGLE_ALBUM_MEMBERSHIP_GROUP_FILTER: {
      return {
        ...state,
        albumMembershipGroupFilters: state.albumMembershipGroupFilters.includes(
          action.id,
        )
          ? state.albumMembershipGroupFilters.filter(id => id !== action.id)
          : [...state.albumMembershipGroupFilters, action.id],
      };
    }

    case CLEAR_ALBUM_MEMBERSHIP_GROUP_FILTERS: {
      return {
        ...state,
        albumMembershipGroupFilters: initialState.albumMembershipGroupFilters,
      };
    }

    default:
      return state;
  }
};

export default membershipsReducer;
